import {Component,Inject,OnInit} from "@angular/core";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {ZoneUtilisateur} from "@domain/zone-utilisateur/zone-utilisateur";
import {PrestationService} from "@services/admin/frais/prestation.service";
import {first} from "rxjs/operators";

/**
 * Composant d'ajout d'une ZU
 */
@Component({
    host: {'data-test-id': 'add-zu'},
    templateUrl: './add-zu.component.html'
})
export class AddZuComponent implements OnInit {
    /** ZU à ajouter */
    zu: ZoneUtilisateur;

    /** Liste des ZU possibles pour le select */
    listeZu: Array<ZoneUtilisateur> = [];

    /** Forçage de l'erreur sur le select */
    hasForcedError: boolean = true;

    /**
     * Constructeur
     */
    constructor(protected matDialogRef: MatDialogRef<AddZuComponent>,
                private prestationService: PrestationService,
                @Inject(MAT_DIALOG_DATA) public data: { idPrestation: number, zu?: ZoneUtilisateur }) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Initialisation de la ZU
        this.zu = this.data.zu ? { ...this.data.zu } as ZoneUtilisateur : new ZoneUtilisateur();

        //Si une ZU est fournie
        if (this.data.zu) {
            //Ajout de la ZU dans la liste
            this.listeZu.push(this.zu);

            //Mise à jour des champs
            this.onZuChange();
        }

        //Récupération de la liste des ZU possibles
        this.prestationService.listeZoneUtilisateurPossible(this.data.idPrestation).pipe(first())
                                .subscribe(f => this.listeZu = this.data.zu ? f.concat(this.data.zu) : f);
    }

    /**
     * Ajout de la ZU
     */
    add(): void {
        //Sauvegarde de la ZU
        this.prestationService.saveLienZuPrest(this.data.idPrestation,this.zu).pipe(first()).subscribe(f => {
            //Fermeture de la boite de dialogue avec retour de la nouvelle ZU
            this.matDialogRef.close(this.zu);
        });
    }

    /**
     * Détection d'un changement sur la ZU
     */
    onZuChange() {
        //Si une ZU est fournie
        if (this.data.zu) {
            //Récupération des informations du lien original
            this.zu.idLienZuPrest = this.data.zu.idLienZuPrest;
        }

        //Retrait de l'erreur sur le select
        this.hasForcedError = false;
    }
}
